import { env } from './.env';

export const environment = {
  production: true,
  version: env['npm_package_version'],
  serverUrl: 'https://rawi.sbk1.at/api',
  authUrl: 'https://rawi.sbk1.at/api/auth',  // Public auth endpoints
  apiUrl: 'https://rawi.sbk1.at/api/v5',    // Protected API endpoints
  //webstorage: 'https://rawi.sbk1.at.at/api/storage/',
  contactLoginUrl: 'https://rawi.sbk1.at', // Contact portal URL for login as
  defaultLanguage: 'de-DE',
  supportedLanguages: ['de-DE', 'en-US', 'sv-SE'],
  api_key: 'sbk1-rawi.at-12394w23x.dfsa332wqadfdsaf',


// =====================================================
  // CONFIGURATION ARRAYS FOR HARDCODED VALUES
  // =====================================================

  // Default names used by the "Quick-Anlage" action when generating a
  // complete Objekt-Struktur (Gebäude > Sektion > Raum) in one go.
  objektStrukturDefaults: {
    gebaeude: 'Hauptgebäude',
    sektion: 'Keller',
    raum: 'Kellerraum'
  },

  // Indikator Symbol mapping
  indikatorSymbolBasePath: '/assets/symbols',
  indikatorSymbolMap: {
    // Available symbol files (SVG): rect, layer, paper, circ, poly, tri
    // Map database symbol_id values to actual symbol files
    '1': 'rect',
    '2': 'poly', 
    '3': 'circ',
    '4': 'tri',
    '6': 'paper',
    '7': 'layer'
  },

  // Indikator Symbol Color mapping
  indikatorSymbolColorMap: {
    '1': '#3b82f6',  // rect - blue
    '2': '#10b981',  // poly - green
    '3': '#f59e0b',  // circ - orange
    '4': '#ef4444',  // tri - red
    '6': '#8b5cf6',  // paper - purple
    '7': '#06b6d4'   // layer - cyan
  },

  // Enhanced Symbol Shape Configuration for Konva
  indikatorSymbolShapeMap: {
    '1': { // rect
      symbol_id: '1',
      shape: 'rect',
      size: 24,
      fill: '#ffffff',
      stroke: '#3b82f6',
      strokeWidth: 2,
      color: '#3b82f6'
    },
    '2': { // poly
      symbol_id: '2',
      shape: 'polygon',
      size: 24,
      fill: '#ffffff',
      stroke: '#10b981',
      strokeWidth: 2,
      points: [0, -12, 12, 12, -12, 12], // Triangle
      color: '#10b981'
    },
    '3': { // circ
      symbol_id: '3',
      shape: 'circle',
      size: 24,
      fill: '#ffffff',
      stroke: '#f59e0b',
      strokeWidth: 2,
      color: '#f59e0b'
    },
    '4': { // tri
      symbol_id: '4',
      shape: 'polygon',
      size: 24,
      fill: '#ffffff',
      stroke: '#ef4444',
      strokeWidth: 2,
      points: [0, -12, 12, 12, -12, 12], // Triangle
      color: '#ef4444'
    },
    '6': { // paper
      symbol_id: '6',
      shape: 'rect',
      size: 24,
      fill: '#ffffff',
      stroke: '#8b5cf6',
      strokeWidth: 2,
      color: '#8b5cf6'
    },
    '7': { // layer
      symbol_id: '7',
      shape: 'image',
      size: 24,
      fill: '#ffffff',
      stroke: '#06b6d4',
      strokeWidth: 2,
      imageUrl: '/assets/symbols/layer.svg',
      color: '#06b6d4'
    }
  },

  // Indikator Status Options
  indikator_status: [
    { id: 1, value: 'aktiv', label: 'Aktiv' },
    { id: 0, value: 'inaktiv', label: 'Inaktiv' }
  ],

  // Projektaufgabe Periodizitaet Options (DEPRECATED - use periode_aufgaben instead)
  projektaufgabe_periodizitaet: [
    { id: 1, value: 'wöchentlich', label: 'Wöchentlich' },
    { id: 2, value: 'monatlich', label: 'Monatlich' },
    { id: 3, value: 'alle_2_monate', label: 'Alle 2 Monate' },
    { id: 4, value: 'quartalsweise', label: 'Quartalsweise' },
    { id: 5, value: 'halbjährlich', label: 'Halbjährlich' },
    { id: 6, value: 'jährlich', label: 'Jährlich' },
    { id: 7, value: 'alle_4_monate', label: '3x jährlich (alle 4 Monate)' }
  ],

  // Projektaufgabe Status Options
  projektaufgabe_status: [
    { id: 1, value: 'aktiv', label: 'Aktiv' },
    { id: 0, value: 'inaktiv', label: 'Inaktiv' }
  ],

  // Projektaufgabe Einsatztyp Options
  projektaufgabe_einsatztyp: [
    { value: 'kontrolle', label: 'Kontrolle' },
    { value: 'notfall', label: 'Notfall' },
    { value: 'monitoring', label: 'Monitoring' },
    { value: 'zusatz', label: 'Zusatz' }
  ],

  // Kontrolltermin Einsatztyp Options
  kontrolltermin_einsatztyp: [
    { value: 'kontrolle', label: 'Kontrolle' },
    { value: 'notfall', label: 'Notfall' }
  ],

  // Kontrolltermin Status Options
  kontrolltermin_status: [
    { id: 1, value: 'geloescht', label: 'Gelöscht' },
    { id: 2, value: 'abgebrochen', label: 'Abgebrochen' },
    { id: 3, value: 'fehlerhaft', label: 'Fehlerhaft' },
    { id: 4, value: 'geplant', label: 'Geplant' },
    { id: 5, value: 'aktuell', label: 'Aktuell' },
    { id: 6, value: 'in_bearbeitung', label: 'In Bearbeitung' },
    { id: 7, value: 'freigabe', label: 'Freigabe' },
    { id: 8, value: 'abgeschlossen', label: 'Abgeschlossen' }
  ],

  // Kontroll Indikator Befall Ampel Options
  kontroll_indikator_befall_ampel: [
    { id: 1, value: 'gruen', label: 'Grün', threshold: 0, color: '#28a745' },
    { id: 2, value: 'orange', label: 'Orange', threshold: 3, color: '#ffc107' },
    { id: 3, value: 'rot', label: 'Rot', threshold: 7, color: '#dc3545' }
  ],

  // Client Status Options
  client_status: [
    { id: 1, value: 'aktiv', label: 'Aktiv' },
    { id: 2, value: 'inaktiv', label: 'Inaktiv' }
  ],

  // Kontakt Status Options
  kontakt_status: [
    { id: 1, value: 'aktiv', label: 'Aktiv' },
    { id: 2, value: 'inaktiv', label: 'Inaktiv' }
  ],

  // Mitarbeiter Status Options
  mitarbeiter_status: [
    { id: 1, value: 'aktiv', label: 'Aktiv' },
    { id: 2, value: 'inaktiv', label: 'Inaktiv' }
  ],

  // Standorte Status Options
  standorte_status: [
    { id: 1, value: 'aktiv', label: 'Aktiv' },
    { id: 2, value: 'inaktiv', label: 'Inaktiv' }
  ],

  // Bericht Sprache Options
  bericht_sprache: [
    { value: 'de', label: 'Deutsch' }
  ],

  // Bericht Versand Options
  bericht_versand: [
    { value: 'mail', label: 'E-Mail' },
    { value: 'post', label: 'Post Sendung' }
  ],

  // Periode Aufgaben Options
  periode_aufgaben: [
    { id: 1, value: 'wöchentlich', label: 'Wöchentlich' },
    { id: 2, value: 'monatlich', label: 'Monatlich' },
    { id: 3, value: 'alle_2_monate', label: 'Alle 2 Monate' },  // DEFAULT
    { id: 4, value: 'quartalsweise', label: 'Quartalsweise' },
    { id: 5, value: 'halbjährlich', label: 'Halbjährlich' },
    { id: 6, value: 'jährlich', label: 'Jährlich' },
    { id: 7, value: 'alle_4_monate', label: '3x jährlich (alle 4 Monate)' }
  ]
};